/* tslint:disable */
const TRANSLATIONS: any = {
  "i18n.additionalProducts.addToCart": "Legg til bestilling",
  "i18n.additionalProducts.emotionalHook": "♥️ Populært:",
  "i18n.additionalProducts.productDescription": "Produktbeskrivelse",
  "i18n.additionalProducts.showMore": "Mer informasjon",
  "i18n.additionalProducts.title": "Tilbehør",
  "i18n.button.addToCart": "Legg til handlekurv",
  "i18n.button.cropImage": "",
  "i18n.button.apply": "Bruk",
  "i18n.button.back": "Tilbake",
  "i18n.button.cancel": "Avbryt",
  "i18n.button.cancelAndFix": "",
  "i18n.button.cancelAndAddImage": "",
  "i18n.button.close": "Lukk",
  "i18n.button.continue": "Fortsett",
  "i18n.button.ignore": "Ignorer",
  "i18n.button.ignoreAndContinue": "Fortsett",
  "i18n.button.ignoreAndContinueOrder": "",
  "i18n.button.mobile.createNewTextPlaceholders": "Tekst",
  "i18n.button.noChanges": "Nei takk, lukk vinduet ",
  "i18n.button.design": "",
  "i18n.button.photos": "Bilder",
  "i18n.button.retry": "Prøv på nytt",
  "i18n.button.uploadPhotos": "Last opp bilde(r)",
  "i18n.button.withSmartSorted": "oppgrader til SMART SORTED ",
  "i18n.button.withoutSmartSorted": "Nei takk, lukk vinduet ",
  "i18n.button.continueDesigning": "",
  "i18n.button.returnToHomePage": "",
  "i18n.button.deleteImage": "",
  "i18n.button.withoutPhoto": "",
  "i18n.button.withoutThisPhoto": "",
  "i18n.button.chooseNewImage": "",
  "i18n.button.chooseOtherPhoto": "",
  "i18n.button.retryPhoto": "",
  "i18n.button.reload": "",
  "i18n.button.restartDesigner": "",
  "i18n.button.restart": "",
  "i18n.button.puzzleYouShop": "",
  "i18n.button.shop": "",
  "i18n.button.changeProduct": "",
  "i18n.button.keepProduct": "",
  "i18n.toggle.hidePuzzleOverlay": "",
  "i18n.toggle.showPuzzleOverlay": "",
  "i18n.toggle.hide": "",
  "i18n.toggle.showUsedImages": "",
  "i18n.toggle.hideUsedImages": "",
  "i18n.imagePromoter.title": "",
  "i18n.imagePromoter.content": "",
  "i18n.boxPromoter.title.puzzle": "",
  "i18n.boxPromoter.title.memo": "",
  "i18n.boxPromoter.title.default": "",
  "i18n.boxPromoter.content.designsAndText": "",
  "i18n.boxPromoter.content.designs": "",
  "i18n.boxPromoter.content.text": "",
  "i18n.control.colorChooser.matchingColors": "",
  "i18n.control.colorChooser.allColors": "",
  "i18n.control.colorChooser.allBgColors": "",
  "i18n.control.colorChooser.lowContrastHint": "",
  "i18n.control.fontChooser.group.classic": "",
  "i18n.control.fontChooser.group.creative": "",
  "i18n.control.fontChooser.group.handwritten": "",
  "i18n.control.fontChooser.group.modern": "",
  "i18n.control.fontChooser.group.technical": "",
  "i18n.control.imageQuality.title.good": "",
  "i18n.control.imageQuality.title.medium": "",
  "i18n.control.imageQuality.title.bad": "",
  "i18n.control.imageQuality.content.good": "",
  "i18n.control.imageQuality.content.medium": "",
  "i18n.control.imageQuality.content.bad": "",
  "i18n.control.imageQuality.affectedImages": [
    "",
    ""
  ],
  "i18n.control.imageQuality.showIndicators": "",
  "i18n.control.imageQuality.hideIndicators": "",
  "i18n.control.imageZoom.zoom": "Zoom:",
  "i18n.control.textEditing.menu.fonts": "",
  "i18n.control.textEditing.menu.effects": "",
  "i18n.control.textEditing.menu.colors": "",
  "i18n.control.textEditing.menu.bgColors": "",
  "i18n.control.textEditing.rejectMessage.characterWontFit": "For bedre lesbarhet, reduser lengden på teksten/linjen.",
  "i18n.control.textEditing.rejectMessage.fontFamilyTooLarge": "Valgt font er for stor for denne teksten.",
  "i18n.control.textEditing.rejectMessage.fontSizeTooLarge": "Maks. mulig fontstørrelse for denne teksten er nådd.",
  "i18n.control.textEditing.rejectMessage.fontSizeTooSmall": "Min. mulig fontstørrelse for denne teksten er nådd.",
  "i18n.control.textEditing.rejectMessage.insertLineBreak": "Vennligst legg inn et linjeskift",
  "i18n.control.textEditing.rejectMessage.insertLineBreakOrResizeTextField": "Fortsett å skrive i en annen linje eller forstørre tekstfeltet",
  "i18n.control.textEditing.rejectMessage.invalidCharacters": "Vennligst sjekk teksten din, ikke alle tegn støttes av denne fonten.",
  "i18n.control.textEditing.rejectMessage.maxCharactersReached": "",
  "i18n.control.textEditing.rejectMessage.maxLinesReached": "For bedre lesbarhet, reduser lengden på teksten/linjen.",
  "i18n.control.textEditing.rejectMessage.resizeTextField": "Vennligst forstørre tekstfeltet",
  "i18n.dialog.closeDesigner.message": "",
  "i18n.dialog.closeDesigner.title": "",
  "i18n.dialog.deletePlaceholder.message": "Dette trinnet kan ikke angres",
  "i18n.dialog.deletePlaceholder.title": "Vil du slette plassholderen?",
  "i18n.dialog.deleteGalleryImage.title": "",
  "i18n.dialog.deleteGalleryImage.message": "",
  "i18n.dialog.insufficientImageQuality.message": "Oppløsningen på bildet er for lav til å oppnå et skarpt utskriftsresultat!",
  "i18n.dialog.smartSorted.message": "Med SMART SORTED legges puslespill med 1000 brikker på nyskapende og lettvint vis, også uten å ha motivet som forlegg. ",
  "i18n.dialog.smartSorted.title": "Garantert puslesuksess",
  "i18n.dialog.unchangedPlaceholders.boxTitle.message": "Klikk på \"{{text}}\", for å endre tittelen på esken.",
  "i18n.dialog.unchangedPlaceholders.boxTitle.title": "Esketittelen er ikke endret",
  "i18n.dialog.unchangedPlaceholders.buttons.addTitle.label": "",
  "i18n.dialog.unchangedPlaceholders.buttons.clear.label": "Fortsett uten en tittel",
  "i18n.dialog.unchangedPlaceholders.image.message": [
    "",
    ""
  ],
  "i18n.dialog.unchangedPlaceholders.image.title": [
    "",
    ""
  ],
  "i18n.dialog.unchangedPlaceholders.message": [
    "En plassholder har ikke blitt endret",
    "Flere plassholdere har ikke blitt endret."
  ],
  "i18n.dialog.unchangedPlaceholders.text.message": [
    "",
    ""
  ],
  "i18n.dialog.unchangedPlaceholders.text.title": [
    "",
    ""
  ],
  "i18n.dialog.unchangedPlaceholders.title": "Uendrede plassholdere",
  "i18n.dialog.productChooserWarning.title": "",
  "i18n.dialog.productChooserWarning.message": "",
  "i18n.dialog.imageQuality.title": "",
  "i18n.dialog.imageQuality.indicator.good": "",
  "i18n.dialog.imageQuality.indicator.medium": "",
  "i18n.dialog.imageQuality.indicator.bad": "",
  "i18n.dialog.imageQuality.subtitle.good": "",
  "i18n.dialog.imageQuality.subtitle.medium": "",
  "i18n.dialog.imageQuality.subtitle.bad": "",
  "i18n.dialog.imageQuality.content.good": "",
  "i18n.dialog.imageQuality.content.medium": "",
  "i18n.dialog.imageQuality.content.bad": "",
  "i18n.error.deprecatedBrowserError.message": "",
  "i18n.error.deprecatedBrowserError.title": "",
  "i18n.error.designerExpiredError.message": "Det har gått for lang tid siden du startet designprosessen og den kan derfor ikke fortsettes. Vennligst start på nytt.",
  "i18n.error.designerExpiredError.title": "",
  "i18n.error.fontLoadingError.message": "",
  "i18n.error.fontLoadingError.title": "",
  "i18n.error.imageLoadingError.message": "Et bilde kunne ikke lastes inn. Den ble fjernet fra designområdet og galleriet.",
  "i18n.error.imageLoadingError.title": "Nedlastningsfeil",
  "i18n.error.imageProvisionError.message": "Ett eller flere bilder kunne ikke behandles. Medietypen støttes sannsynligvis ikke.",
  "i18n.error.imageProvisionError.title": "",
  "i18n.error.imageSelectionError.message": "Filen \"{{reference1}}\" kunne ikke behandles.",
  "i18n.error.imageSelectionError.title": "Det oppstod en feil under opplasting av bilde",
  "i18n.error.imageSizeLimitExceededError.message": "Bildet du lastet opp er for stort.\nReduser bildet ditt til under 180 megapiksler og last det opp igjen.",
  "i18n.error.imageSizeLimitExceededError.title": "Det oppstod en feil under opplasting av bilde",
  "i18n.error.imageUploadError.message": "Det oppstod et feil med Internettilkoblingen.\nPrøv igjen senere.",
  "i18n.error.imageUploadError.title": "Det oppstod en feil under opplasting av bilde",
  "i18n.error.inlineSVGLoadingError.message": "",
  "i18n.error.inlineSVGLoadingError.title": "",
  "i18n.error.invalidCharConfigError.message": "Denne skriften er ikke aktuelt, vennligst velg en annen font.",
  "i18n.error.invalidCharConfigError.title": "Skrift ikke aktuelt",
  "i18n.error.malformedProductError.message": "",
  "i18n.error.malformedProductError.title": "",
  "i18n.error.notInStockError.message": "",
  "i18n.error.notInStockError.title": "",
  "i18n.error.offlineNotice": "Internettilkoblingen din ble avbrutt. Du kan fortsette å designe produktet ditt når tilkoblingen er gjenopprettet.",
  "i18n.error.templateLoadingError.message": "Oppsett \"{{ error.reference[0] }}\" kan ikke lastes inn.\nPrøv igjen senere.",
  "i18n.error.templateLoadingError.title": "Nedlastningsfeil",
  "i18n.error.traudlLoadingError.message": "",
  "i18n.error.traudlLoadingError.title": "",
  "i18n.error.unsupportedMediaTypeError.message": "\"{{reference1}}\" har en ustøttet medietype.",
  "i18n.error.unsupportedMediaTypeError.title": "Det oppstod en feil under opplasting av bilde",
  "i18n.error.uploadProductError.message": "Ett eller flere produkter kan ikke overføres til serveren.\nPrøv igjen senere.",
  "i18n.error.uploadProductError.title": "Overføringsfeil",
  "i18n.error.zoomModeError.message": "Teksten fra den forrige layouten kunne ikke overtas. Vennligst skriv inn en ny tekst.",
  "i18n.error.zoomModeError.title": "Tekst ikke overtas",
  "i18n.gallery.uploadPhotos.title": "",
  "i18n.gallery.uploadPhotos.message": "",
  "i18n.gallery.placedAllPhotos.title": "",
  "i18n.gallery.placedAllPhotos.message": "",
  "i18n.price.price": "Pris",
  "i18n.price.reduction": "Du sparer",
  "i18n.price.total": "Totalbeløp",
  "i18n.priceDisplay.times": [
    "{{value}} vare på {{pricePerUnit}}",
    "{{value}} varer på {{pricePerUnit}}"
  ],
  "i18n.progress.stepAdditionalProducts": "Velg tilbehør",
  "i18n.progressOverlay.message.lines.one": "Bra jobbet!",
  "i18n.progressOverlay.message.lines.two": "Vi klargjør neste steg til deg...",
  "i18n.template.insertText": "Du kan skrive inn en tekst her",
  "i18n.toolbox.image.title": "Rediger bilde",
  "i18n.toolbox.layout.template.count": [
    "",
    ""
  ],
  "i18n.toolbox.layout.template.inUse": "",
  "i18n.toolbox.layout.template.suitableFor": [
    "1 bilde",
    "{{value}} bilder"
  ],
  "i18n.toolbox.layout.title": "",
  "i18n.toolbox.layout.titleBox": "",
  "i18n.toolbox.preview.title": "3D-Forhåndsvisning",
  "i18n.toolbox.productChooser.title": "Endre produkt",
  "i18n.toolbox.productChooser.triggerText": "Produkt",
  "i18n.toolbox.productChooser.contentMessage.one": "",
  "i18n.toolbox.productChooser.contentMessage.two": "",
  "i18n.toolbox.textEdit.title": "",
  "i18n.toolbox.textEdit.noPlaceholdersTitle": "",
  "i18n.toolbox.textEdit.noPlaceholdersMessage": "",
  "i18n.toolbox.textEdit.noPlaceholdersButton": "",
  "i18n.toolbox.text.title": "Rediger tekst",
  "i18n.toolbox.imageEdit.title": "",
  "i18n.toolbox.imageEdit.removeImageMobile": "",
  "i18n.toolbox.imageEdit.removeImageDesktop": "",
  "i18n.toolbox.imageEdit.swapImage": ""
};


export class LocaleNbNO {
  public getPlural(n: number): number
  {
    const pluralForm = (n != 1);
    if (typeof(pluralForm) === 'boolean') {
      return pluralForm ? 1 : 0;
    }
    return pluralForm;
  }
  public getTranslations(): any
  {
    return TRANSLATIONS;
  }
}
/* tslint:enable */
